import { z } from "zod";

/**
 * Search-param schema for the `/hardware` route.
 *
 * `serial` is the row identity for hardware — there is no numeric id. Serials
 * like `ZB1-A001-77F2` survive TanStack Router's `JSON.parse` search parser as
 * raw strings, but coerce anyway (a purely numeric serial would arrive as a
 * number) and `.catch` back to "nothing selected" rather than throwing: a
 * ZodError here takes down the router's loader pipeline. See
 * `usersSearchSchema` for the incident that taught us this.
 */
export const hardwareSearchSchema = z.object({
  serial: z.coerce.string().optional().catch(undefined),
});

export type HardwareRouteSearch = z.infer<typeof hardwareSearchSchema>;
